import * as $ from "jquery";
import * as _ from "lodash";
import * as moment from "moment-timezone";
import "select2";
import { getIAQChannelType } from "../../../../../../common/channelUtils";
import { ModuleCollection } from "../../../../collections/Modules";
import { TimezoneCollection } from "../../../../collections/Timezones";
import { Utils } from "../../../../common/utils";
import { DashboardChannel } from "../../../../models/DashboardChannel";
import {
    CHART_DATA_RANGE,
    DAILY_TIME_MODE,
} from "../../../dashboard/widgets/chart/ChartHelper";
import {
    BaseModifyDashboardWidgetView,
    BaseModifyDashboardWidgetViewOptions,
} from "../../dashboard/modify_widgets/_BaseModifyWidgetView";

declare const App: any;

export class ModifyCSVDataWidgetView extends BaseModifyDashboardWidgetView {
    // Templates
    private template = _.template(
        require("templates/modals/reports/modify_widgets/csvdatawidget/csvdatawidget.html")
    );
    private referenceChannelsTemplate = _.template(
        require("templates/modals/reports/modify_widgets/csvdatawidget/referenceChannel.html")
    );
    private deviceSourceTemplate = _.template(
        require("templates/modals/reports/modify_widgets/csvdatawidget/deviceSource.html")
    );

    private dailyTimeFormat = "hh:mm A";
    private dateTimePickerFormat = "MM/DD/YYYY h:mm A";
    private widgetChannels: DashboardChannel[];
    private aggFnByChannelType: Map<string, number[]>= new Map();
    private aggregationFunctions: number[] = [];

    constructor(options: BaseModifyDashboardWidgetViewOptions) {
        super(
            <any>_.extend({
                    tagName: "div",
                    className: "widget-type-channels csv-data-widget",
                    events: {
                        'change .aggregation-period select': 'handleAggregationPeriodChange',
                        'change .data-range select': 'handleRangeChange',

                        "click .add-reference-channel-btn": "handleAddReferenceChannelBtnClick",
                        "click .add-site-btn": "handleAddSiteBtnClick",
                        "click .add-site-all-btn": "handleAddAllSitesBtnClick",

                        // Chart Channel Changes
                        "change .widget-reference-select-install": "handleReferenceInstallSelectChange",
                        "change .widget-reference-select-module": "handleReferenceModuleSelectChange",
                        "change .widget-reference-select-channel": "handleReferenceChannelSelectChange",
                        "click .widget-reference-channel-delete": "handleChannelDelete",

                        // Device source select changes
                        "change .widget-device-source-install": "handleDeviceInstallSelectChange",
                        "click .widget-device-source-delete": "handleDeviceSourceDelete",
                        "click .select-all-modules-btn": "handleSelectAllModules",

                    },
                }, options
            )
        );

        this.widgetChannels = [];
        if (!this.options.widget) {
            this.options.widget = new this.options.dashboardWidgetCollection.model({
                dashboard_id: this.options.dashboardId,
                params: [
                    { key: 'CHART_TITLE', value: '' },
                    { key: 'CHART_AGGREGATION_TYPE', value: '1' },
                    { key: 'CHART_AGGREGATION_PERIOD', value: '0' },
                    { key: 'CHART_DATA_RANGE', value: '2' },
                    { key: 'CHART_TIMEZONE', value: this.options.currentUser.get('timezone') },
                ]
            });
            this.widgetChannels = [];
        } else {
            this.widgetChannels = this.options.dashboardChannelCollection
                .where({ dashboard_widget_id: this.options.widget.get("id") });
        }
    }

    render() {
        // remove module collections so we can refetch them
        this.options.moduleCollections = {};

        this.$el.html(
            this.template({
                dashboardCategoryCollection:
                    this.options.dashboardCategoryCollection,
                widget: this.options.widget,
                exampleImg: require("../../../../../img/widgettypes/csvdata/csvdatawidgetexample.png"),
                categoryId: this.options.widget.get("dashboard_category_id")
                    ? this.options.widget.get("dashboard_category_id")
                    : this.options.categoryId,
                report: this.options.report,
                currentUser: this.options.currentUser,
                dateTimePickerFormat: this.dateTimePickerFormat,
                dailyTimeFormat: this.dailyTimeFormat,
                timezones: new TimezoneCollection(),
                organizationCollection: this.options.organizationCollection,
                installCollection: this.options.installCollection,
                lastSelectedInstallId: App.getLastSelectedInstallId(),
            })
        );
        this.$("select").select2(Utils.Select2.defaultOptions);
        //Initialize bootstrap toggle for advanced configuration
        (<any>this.$el.find('input[type="checkbox"]')).bootstrapToggle();

        if (!this.options.widget.isNew()) {
            this.buildInitialChannels();
        } else {
            // trigger install select and populate modules
            this.$(".widget-reference-select-install").trigger("change");
        }

        this.handleRangeChange();
        this.setUpUIElements();

        return this;
    }

    show() {
        // Refit selects to container width after it is rendered on screen
        this.$(".channels")
            .find("select")
            .select2(Utils.Select2.defaultOptions);
        this.initializeCategorySelect(".category select");
    }

    private buildInitialChannels() {
        // Get aggregation types for total widget
        const aggTypes = this.options.widget
            .getParamValue("CHART_AGGREGATION_TYPE", "")
            .split(",");

        const widgetId = this.options.widget.get("id");
        // Find reference channels
        const referenceChannels = this.options.dashboardChannelCollection.where({
            dashboard_channel_secondary_order: 0,
            dashboard_widget_id: widgetId,
        });

        // Set reference install and module select values
        const referenceInstallID = referenceChannels[0].get('install_id');
        const referenceModuleNumber = referenceChannels[0].get('module_number');
        const referenceInstallSelect = this.$(".reference-sources").find(".widget-reference-select-install");
        referenceInstallSelect.val(referenceInstallID).trigger("change");
        this.$(".reference-sources").find('.widget-reference-select-channel').prop('disabled', true);

        // Load the modules to populate the reference selects
        if (!_.has(this.options.moduleCollections, referenceInstallID)) {
            this.options.moduleCollections[referenceInstallID] = new ModuleCollection([], { installId: Number(referenceInstallID) });
        }
        const moduleCollectionDeferred = this.options.moduleCollections[referenceInstallID].getCollectionFetchPromise();
        $.when(moduleCollectionDeferred).done(() => {
            selectReferenceModuleChannel();
        });

        const selectReferenceModuleChannel = () => {
            // Select the module
            const referenceModuleSelect = this.$(".reference-sources").find(".widget-reference-select-module")
            referenceModuleSelect.val(referenceModuleNumber).trigger("change");

             // Set reference channel values
            for (let [i, rchannel] of referenceChannels.entries()) {
                let row;
                if(i === 0){
                    row = this.$(".reference-sources").find(".reference-channel-selects");
                    row.find('.widget-reference-select-channel').prop('disabled', false);
                } else {
                    row = this.renderNewReferenceChannelRow();
                }

                row.find(".widget-dashboard-channel-id").val(rchannel.get("dashboard_channel_id"));
                row.find('.widget-reference-select-channel').val(rchannel.get('channel_id')).trigger('change');

                const aggType = aggTypes[Number(rchannel.get("dashboard_channel_order"))];
                row.find(".widget-reference-channel-select-aggregation-type").val(aggType).trigger("change");

                // Fill in the Dashboard Channel Id
                row.find(".widget-dashboard-channel-id").val(rchannel.get("dashboard_channel_id"));
                row.find(".widget-reference-select-channel").data("channelId", rchannel.get("channel_id"));
            }
        };

        // Set devices
        // Find device modules
        const deviceChannels = this.options.dashboardChannelCollection.where({
            dashboard_channel_secondary_order: 1,
            dashboard_widget_id: widgetId,
        });
        const selectedModulesByInstallID: Map<string, string[]> = new Map();
        for (const dchannel of deviceChannels) {
            const installID = dchannel.get('install_id');
            const moduleNumber = dchannel.get('module_number');
            if (!selectedModulesByInstallID.has(installID)) {
                selectedModulesByInstallID.set(installID, []);
            }
            // prevent duplicate entries for module number
            const isPresent = selectedModulesByInstallID.get(installID).indexOf(moduleNumber);
            if(isPresent === -1) selectedModulesByInstallID.get(installID).push(moduleNumber);
        }

        // Load the modules to populate the selects
        for (let [installID, modules] of  selectedModulesByInstallID.entries()) {
            const row = this.renderNewDeviceRow(installID);

            // Wait for the module collections to sync before selecting them
            this.options.moduleCollections[installID].once("sync", () => {
                row.find('.widget-device-source-module').val(modules).trigger('change');
            });
        }
    }

    private renderNewDeviceRow(installID?) {
        const newDeviceSourceRow = $(
            <string>this.deviceSourceTemplate({
                organizationCollection: this.options.organizationCollection,
                installCollection: this.options.installCollection,
                lastSelectedInstallId: installID,
                report: this.options.report,
            })
        );
        this.$(".device-sources").append(newDeviceSourceRow);

        newDeviceSourceRow.find(".widget-device-source-install").select2(Utils.Select2.defaultOptions);
        newDeviceSourceRow.find(".widget-device-source-module").select2(
            _.extend({ disabled: true }, Utils.Select2.defaultOptions)
        );

        // Immediately trigger a change so that preselected installs cause modules to be fetched
        newDeviceSourceRow.find(".widget-device-source-install").trigger("change");

        this.checkCanSaveWidget();
        this.delegateEvents();

        return newDeviceSourceRow;
    }

    private renderNewReferenceChannelRow() {
        const installSelect = this.$(".reference-sources").find(".widget-reference-select-install");
        const installID = <string>$(installSelect).val() || App.getLastSelectedInstallId();
        const noAggregation = this.$('.aggregation-period select').val() === '0';

        const newChannelRow = $(
            <string>this.referenceChannelsTemplate({
                lastSelectedInstallId:
                installID || App.getLastSelectedInstallId(),
                report: this.options.report,
                noAggregation: noAggregation
            })
        );
        this.$(".reference-channels").append(newChannelRow);

        const channelSelect = newChannelRow.find(".widget-reference-select-channel");
        channelSelect.select2(_.extend({ disabled: true }, Utils.Select2.defaultOptions));
        this.$(".reference-channels").find("select").select2(Utils.Select2.defaultOptions);

        // Populate channel select
        channelSelect.empty();
        const channelOptions = [{ id: "", text: "" }];
        const moduleSelect = this.$(".reference-sources").find('.widget-reference-select-module');
        const moduleNumber = <string>$(moduleSelect).val() || "";
        if (moduleNumber) {
            const module = this.options.moduleCollections[installID].findWhere({
                module_number: moduleNumber,
            });
            if (module) {
                _.each([1, 2, 3, 4], (connector) => {
                    const con = module.getConnector(connector);
                    if (con) {
                        let label = "Connector " + connector + ": " + con["sensor_name"];
                        if (!module.showConnector(connector))
                            label += " (disconnected)";

                        const optgroup = { text: label, children: [] };
                        _.each(
                            _.sortBy(con.channels, "channel_position"),
                            (c) => {
                                optgroup.children.push({
                                    id: c["channel_id"],
                                    text: c["channel_name"],
                                });
                            }
                        );

                        channelOptions.push(<any>optgroup);
                    }
                });
            }
        }
        channelSelect.select2(_.extend({
                disabled: !moduleNumber.length,
                data: channelOptions,
        }, Utils.Select2.defaultOptions ));
        channelSelect.trigger("change");

        this.checkCanSaveWidget();
        return newChannelRow;
    }


    private buildModuleOptions(installId) {
        const options = [];
        this.options.moduleCollections[installId].each((module) => {
            // Filter Modules that don't have sensors connected. Control sensors are not
            // Considered sensors in this case
            for (let i = 1; i < 5; i++) {
                const con = module.getConnector(i);
                if (con) {
                    if (con["sensor_type"] === 29) continue;

                    const mod = module.get("module_number");
                    const option = {
                        id: mod,
                        text: module.getDisplayName(),
                        selected: "",
                    };
                    options.push(option);
                    break;
                }
            }
        });

        if (options.length) return [{ id: "", text: "" }].concat(options);
        return [{ id: "", text: "No Modules Found" }];
    }

    private setUpUIElements() {
        const toggleButtons = [
            { paramString: "DAILY_TIME_MODE", className: ".daily-time-mode" },
        ];

        _.each(toggleButtons, (button) => {
            const toggleButton = this.$(<string>button.className + " input");
            const paramValue: number = Number(
                this.options.widget.getParamValue(
                    <string>button.paramString,
                    "0"
                )
            );
            const toggleCondition = paramValue >= 2;

            if (toggleCondition) {
                (<any>toggleButton).bootstrapToggle("off");
            } else {
                (<any>toggleButton).bootstrapToggle("on");
            }
        });

        // Set up date selectors for custom data range
        const from = <any>this.$(".data-range-custom-from .date");
        const to = <any>this.$(".data-range-custom-to .date");
        // And for custom daily time
        const dailyCustomStart = <any>this.$(".daily-time-custom-from");
        const dailyCustomEnd = <any>this.$(".daily-time-custom-to");

        from.datetimepicker({
            defaultDate: moment().startOf("day"),
        });
        to.datetimepicker({
            defaultDate: moment().endOf("day"),
            useCurrent: false,
        });
        from.on("dp.change", function (e) {
            to.data("DateTimePicker").minDate(e.date);
        });
        to.on("dp.change", function (e) {
            from.data("DateTimePicker").maxDate(e.date);
        });

        dailyCustomStart.datetimepicker({
            defaultDate: moment(),
            format: this.dailyTimeFormat,
        });
        dailyCustomEnd.datetimepicker({
            defaultDate: moment(),
            format: this.dailyTimeFormat,
        });
    }

    // Events
    private handleAggregationPeriodChange() {
        var aggBlock = this.$('.aggregation-wrapper select');
        if (this.$('.aggregation-period select').val() === '0') {
            aggBlock.prop('disabled', true).trigger("change");
        } else {
            aggBlock.prop('disabled', false).trigger("change");
        }
    }

    private handleRangeChange() {
        const dataRange = String(this.$(".data-range select").val());
        this.$('.data-range-custom-wrapper').toggleClass('hidden', dataRange !== CHART_DATA_RANGE.CUSTOM);
        this.$('.daily-time-custom-wrapper').toggleClass('hidden', dataRange !== CHART_DATA_RANGE.CUSTOM_DAILY);
        this.$('.monthly-billing-range-custom-wrapper').toggleClass('hidden', dataRange !== CHART_DATA_RANGE.CUSTOM_MONTHLY_BILLING);

        const lessThanAMonth = [
            CHART_DATA_RANGE.DAY_1, CHART_DATA_RANGE.DAY_TODAY, CHART_DATA_RANGE.DAY_YESTERDAY, 
            CHART_DATA_RANGE.WEEK_1, CHART_DATA_RANGE.WEEK_CURRENT, CHART_DATA_RANGE.WEEK_LAST, 
            CHART_DATA_RANGE.MONTH_1, CHART_DATA_RANGE.MONTH_CURRENT, CHART_DATA_RANGE.MONTH_LAST, 
        ]
        
        // If user selected a range shorter thatn a month show the 'none' option for the agg period
        // else disable it
        if (lessThanAMonth.includes(dataRange)) {
            this.$('.aggregation-period select option[value="0"]').prop('disabled', false).trigger("change");
        } else {
            if (this.$('.aggregation-period select').val() === '0'){
                this.$('.aggregation-period select').val('8').trigger("change");
            } 
            this.$('.aggregation-period select option[value="0"]').prop('disabled', true).trigger("change");
            
        }
    }

    private handleAddSiteBtnClick(e: JQuery.UIEventBase) {
        e.preventDefault();
        this.renderNewDeviceRow();
    }

    private handleAddAllSitesBtnClick (e: JQuery.UIEventBase) {
        e.preventDefault();
        const installSelect = this.$(".reference-sources").find(".widget-reference-select-install");
        const installID =  Number($(installSelect).val() || App.getLastSelectedInstallId());

        // Find installs for reference organization
        const referenceInstall = this.options.installCollection.findWhere({ id: installID });
        const installs = this.options.installCollection.where({ organization_id: referenceInstall.get('organization_id') });
        if(!installs.length) return; 

        // Clear all selects before adding new ones
        this.$(".device-sources").empty();

        // Add a new row per install and select all modules
        for (const install of installs) {
            const installID = install.get('id');
            const row = this.renderNewDeviceRow(installID);
            row.find(".widget-device-source-module > option").prop("selected", true);
            row.find(".widget-device-source-module").trigger("change");

            // If there are any module collections we haven't fetched, 
            // wait to sync before selecting them
            const moduleCollection = this.options.moduleCollections[installID];
            if(moduleCollection.timesFetched() === 0) {
                moduleCollection.once("sync", () => {
                    row.find(".widget-device-source-module > option").prop("selected", true);
                    row.find(".widget-device-source-module").trigger("change");
                });
            }
        }
    }

    private handleAddReferenceChannelBtnClick(e: JQuery.UIEventBase) {
        e.preventDefault();
        this.renderNewReferenceChannelRow();
    }

    private handleChannelDelete(e: JQuery.UIEventBase) {
        $(e.currentTarget).parents(".reference-channel-selects").remove();

        // Show the add channel button again
        this.$(".add-channel-btn").removeClass("hidden");
        this.checkCanSaveWidget();
    }

    private handleDeviceSourceDelete(e: JQuery.UIEventBase) {
        $(e.currentTarget).parents(".device").remove();
        this.checkCanSaveWidget();
    }

    private handleDeviceInstallSelectChange(e: JQuery.UIEventBase) {
        const installSelect = $(e.currentTarget);
        const installId = Number($(installSelect).val());

        if (!installId) return;

        // Save this as the last selected Id on the dashboard
        App.setLastSelectedInstallId(installId);

        const moduleSelect = installSelect.parents(".device").find(".widget-device-source-module");
        moduleSelect.empty();

        if (this.options.permissionCollection.canViewInstall(Number(installId))) {
            if (!_.has(this.options.moduleCollections, installId)) {
                this.options.moduleCollections[installId] =
                    new ModuleCollection([], { installId: installId });
                this.options.moduleCollections[installId].fetch();
            }

            if (this.options.moduleCollections[installId].isFetching()) {
                moduleSelect.append('<option value="">Loading...</option>');

                this.options.moduleCollections[installId].once("sync", () => {
                    moduleSelect.empty().select2( _.extend(
                        { disabled: false, data: this.buildModuleOptions(installId) },
                        Utils.Select2.defaultOptions )
                    );
                    moduleSelect.trigger("change");
                });
            } else {
                moduleSelect.select2(_.extend({
                    disabled: !installId,
                    data: this.buildModuleOptions(installId)
                }, Utils.Select2.defaultOptions ));
            }
        } else {
            moduleSelect.select2(_.extend({ disabled: !installId }, Utils.Select2.defaultOptions ));
        }

        moduleSelect.trigger("change");
    }

    private handleReferenceChannelSelectChange(e: JQuery.UIEventBase) {
        this.checkCanSaveWidget();
    }

    private handleReferenceInstallSelectChange(e: JQuery.UIEventBase) {
        const installSelect = $(e.currentTarget);
        const installId = Number($(installSelect).val());

        if (!installId) return;

        // Save this as the last selected Id on the dashboard
        App.setLastSelectedInstallId(installId);

        const moduleSelect = this.$(".widget-reference-select-module");
        moduleSelect.empty();

        if (this.options.permissionCollection.canViewInstall(Number(installId))) {
            if (!_.has(this.options.moduleCollections, installId)) {
                this.options.moduleCollections[installId] = new ModuleCollection([], { installId: installId });
                this.options.moduleCollections[installId].fetch();
            }

            if (this.options.moduleCollections[installId].isFetching()) {
                moduleSelect.append('<option value="">Loading...</option>');

                this.options.moduleCollections[installId].once("sync", () => {
                    moduleSelect.empty().select2( _.extend({
                        disabled: false,
                        data: this.buildModuleOptions(installId),
                    }, Utils.Select2.defaultOptions)
                    );
                    moduleSelect.trigger("change");
                });
            } else {
                moduleSelect.select2(_.extend({
                            disabled: !installId,
                            data: this.buildModuleOptions(installId),
                        }, Utils.Select2.defaultOptions )
                );
            }
        } else {
            moduleSelect.select2(_.extend({ disabled: !installId },Utils.Select2.defaultOptions ));
        }

        moduleSelect.trigger("change");
    }

    private handleReferenceModuleSelectChange(e: JQuery.UIEventBase) {
        const moduleSelect = $(e.currentTarget);
        const moduleNumber = <string>$(moduleSelect).val() || "";
        const installSelect = $(moduleSelect).parents(".reference-sources").find(".widget-reference-select-install");
        const installId = <string>$(installSelect).val();

        // Save this as the last selected module number on the dashboard
        App.setLastSelectedModuleNumber(moduleNumber);

        const channelSelects = this.$(".reference-channels").find(".widget-reference-select-channel");
        for (const select of channelSelects) {
            const $select = $(select);
            $select.empty();
            const channelOptions = [{ id: "", text: "" }];
            if (moduleNumber) {
                const module = this.options.moduleCollections[installId].findWhere({
                    module_number: moduleNumber,
                });
                if (module) {
                    _.each([1, 2, 3, 4], (connector) => {
                        const con = module.getConnector(connector);
                        if (con) {
                            let label = "Connector " + connector + ": " + con["sensor_name"];
                            if (!module.showConnector(connector))
                                label += " (disconnected)";

                            const optgroup = { text: label, children: [] };
                            _.each(
                                _.sortBy(con.channels, "channel_position"),
                                (c) => {
                                    optgroup.children.push({
                                        id: c["channel_id"],
                                        text: c["channel_name"],
                                    });
                                }
                            );

                            channelOptions.push(<any>optgroup);
                        }
                    });
                }
            }

            $select.select2(_.extend({
                disabled: !moduleNumber.length,
                data: channelOptions,
            }, Utils.Select2.defaultOptions ));
            $select.trigger("change");
        }
    }

    private handleSelectAllModules(e: JQuery.UIEventBase){
        const deviceElem = $(e.currentTarget).parents(".device");

        deviceElem.find(".widget-device-source-module > option").prop("selected", true);
        $(".widget-device-source-module").trigger("change");
    }

    // Handle save
    getChannelDifference() {
        const installSelect = this.$(".reference-sources").find(".widget-reference-select-install");
        const installID = <string>$(installSelect).val() || App.getLastSelectedInstallId();
        const referenceModuleSelect = this.$(".reference-sources").find('.widget-reference-select-module');
        const referenceModuleNumber = <string>$(referenceModuleSelect).val() || "";

        // Clasify the channels into one of this three operations
        const channelsSeen = [];
        const create = [];
        const update = {};
        const _delete = [];

        // this reference is needed to avoid duplicated pairs of channel and agg fn
        const aggFnsByChannelID: Map<number, number[]>= new Map();
        // This reference is needed to avoid duplicated modules in the additional sources
        const selectedModules: string[] = [referenceModuleNumber];

        // Get reference channels types and agg fn
        const rows = this.$(".reference-channel-selects");
        for (const row of rows) {
            const $row = $(row);
            let channelId = Number($row.find(".widget-reference-select-channel").val());
            const module = this.options.moduleCollections[installID].findWhere({
                module_number: referenceModuleNumber
            });
            const channel = module.getChannelById(channelId);
            if(!channel) continue;

            // Save reference to channel type and agg fn
            // One channel type can have multiple agg fn
            const sensorType = channel.sensor_type;
            const sensorVersion = channel.sensor_version;
            const channelPosition = channel.channel_position;
            const isVirtual = channel['channel_virtual'];
            const channelType = getIAQChannelType(sensorType, sensorVersion, channelPosition, isVirtual);
            const aggType = Number($row.find(".widget-reference-channel-select-aggregation-type").val());

            // If we couldn't find the channel type, skip it
            if(!channelType) continue;

            // If they already selected this cahnnel ID with this agg function, skip it
            const alreadySelected = false;
            const channelID = channel.channel_id;
            if (aggFnsByChannelID.has(channelID)) {
                const isPresent = aggFnsByChannelID.get(channelID).indexOf(aggType)
                if(isPresent > -1) continue;``
            } else {
                aggFnsByChannelID.set(channelID, []);
            }
            aggFnsByChannelID.get(channelID).push(aggType);

            if (!this.aggFnByChannelType.get(channelType)) {
                this.aggFnByChannelType.set(channelType, []);
            }
            this.aggFnByChannelType.get(channelType).push(aggType);

            const dashboardChannelIdField = $row.find('.widget-dashboard-channel-id');
            const dashboardChannelId = Number(dashboardChannelIdField.val());

             //If the row has no channelId, make sure not to delete it if its a result of not having permissions to view an install
             if (!channelId) {
                channelId = $row.find('.widget-channel-select-channel').data('channelId');
                if (channelId) channelsSeen.push(dashboardChannelId);
                continue;
            }

            // Add the agg type to the overall agg types in the same position as the channel
            // Save reference of its position since the order of the channel must match the
            // position of the agg fn in the widget param
            const indexOfCurrentItem = this.aggregationFunctions.push(aggType) - 1;

            // Create channel model to save
            const name = channel['channel_name'];
            // If there is no range configuration we just return the default range
            const rangesList = this.getRangesListFromAdvancedThresholds(row);
            const upsert = {
                dashboardId: this.options.dashboardId,
                widgetId: this.options.widget.get("id"),
                channelId: channelId,
                order: indexOfCurrentItem,
                secondary_order: 0, // this will help identify which are reference channels
                name: name,
                critLow: null,
                warnLow: null,
                warnHigh: null,
                critHigh: null,
                rangesList: rangesList,
            };

            // Identify type of operation (create, update, delete)
            if(dashboardChannelId){
                channelsSeen.push(dashboardChannelId);
                // Make sure we had permission to update this channel
                if (!dashboardChannelIdField.attr('data-ignore-update')) update[dashboardChannelId] = upsert;
            } else {
                create.push(upsert);
            }
        }

        _.each(this.widgetChannels, (c) => {
            var dcid = c.get('dashboard_channel_id');
            if (!_.includes(channelsSeen, dcid)) _delete.push(dcid);
        });

        // Get device module channels
        // Loop through the devices modules and if they have matching channels, add them
        const moduleSelects = this.$('.widget-device-source-module');
        for (const select of moduleSelects) {
            const selectElem = $(select);
            const moduleNumbers = selectElem.val() as Array<string>;
            const installSelect  = selectElem.parents('.device').find('.widget-device-source-install');
            const installID = <string>$(installSelect).val();

            for (const moduleNumber  of moduleNumbers) {
                const module = this.options.moduleCollections[installID].findWhere({
                    module_number: moduleNumber
                });
                if(!module) continue;

                // if the module has already been selected, skip it.
                const isPresent = selectedModules.indexOf(moduleNumber);
                if (isPresent > -1) continue;

                const moduleChannelTypes = [];
                // Loop through module channels and see if we have matching types
                for (const connector of [1, 2, 3, 4]) {
                    const con = module.getConnector(connector);
                    if (con) {
                        for (const channel of con.channels) {
                            const channelWithSensorData = module.getChannelById(channel["channel_id"]);
                            const sensorType = channelWithSensorData.sensor_type;
                            const sensorVersion = channelWithSensorData.sensor_version;
                            const channelPosition = channelWithSensorData.channel_position;
                            const isVirtual = channelWithSensorData['channel_virtual'];
                            const channelType = getIAQChannelType(sensorType, sensorVersion, channelPosition, isVirtual);

                            // if this channel type is not part of the reference types, skip it
                            if (!this.aggFnByChannelType.has(channelType)) continue;

                            // In some edge cases (testing), a module can have multiple channels of the same type
                            // If we already added a channel of this type from this module, skip it so we dont get
                            // multiple values for the same reference
                            const isPresent = moduleChannelTypes.indexOf(channelType);
                            if(isPresent > -1) continue;
                            moduleChannelTypes.push(channelType);

                            const aggTypes = this.aggFnByChannelType.get(channelType);
                            // Add the same channel for each agg type selected
                            for (const aggType of aggTypes) {
                                // Add the agg type to the overall agg types in the same position as the channel
                                // Save reference of its position since the order of the channel must match the
                                // position of the agg fn in the widget param
                                const indexOfCurrentItem = this.aggregationFunctions.push(aggType) - 1;

                                const name = channel['channel_name'];
                                // If there is no range configuration we just return the default range
                                const rangesList = this.getRangesListFromAdvancedThresholds(null);
                                // Create channel model to save
                                const upsert = {
                                    dashboardId: this.options.dashboardId,
                                    widgetId: this.options.widget.get("id"),
                                    channelId: channel['channel_id'],
                                    order: indexOfCurrentItem,
                                    secondary_order: 1, // device channels order should be different than ref channels
                                    name: name,
                                    critLow: null,
                                    warnLow: null,
                                    warnHigh: null,
                                    critHigh: null,
                                    rangesList: rangesList,
                                };

                                // !Until we find a way of identyfing if its either a create or update,
                                // !we just recreate all device channels
                                create.push(upsert);
                            }
                        }
                    }
                }
            }
        }

        // !Until we find a way of identyfing if its either a create or update, we just recreate all device channels
        const widgetId = this.options.widget.get("id");
        const deviceChannels = this.options.dashboardChannelCollection.where({
            dashboard_channel_secondary_order: 1,
            dashboard_widget_id: widgetId,
        });
        for (const dchannel of deviceChannels) {
            _delete.push(dchannel.get('dashboard_channel_id'));
        }

        return [create, update, _delete];
    }

    postSave() {
    // save the aggregation fn types after getting and saving all channels
    this.options.widget.setParamValue("CHART_AGGREGATION_TYPE", this.aggregationFunctions.join(","));

    // the API for postSave is synchronous, but this implementation requires handling of an async XHR operation -- problem!
    this.options.widget.save(); // TODO: fix to not drop the outcome of the XHR
    return true;
    }

    preSave() {
        const aggregationTypesArr =
            _.map(this.$(".widget-reference-channel-select-aggregation-type"), (type) => {
                return $(type).val();
            });

        this.options.widget.setParamValue("CHART_AGGREGATION_TYPE", aggregationTypesArr.join(","));
        this.options.widget.setParamValue('CHART_TITLE', this.$('.chart-title input').val());
        this.options.widget.setParamValue('CHART_AGGREGATION_PERIOD', this.$('.aggregation-period select').val());
            
        const timezone = String(this.$(".timezone select").val());
        this.options.widget.setParamValue("CHART_TIMEZONE", timezone);

        const dataRange = this.$(".data-range select").val();
        this.options.widget.setParamValue("CHART_DATA_RANGE", dataRange);

        this.options.widget.setParamValue(
            "DAILY_TIME_MODE",
            this.$(".daily-time-mode input").is(":checked")
                ? DAILY_TIME_MODE.FULL_RANGE
                : DAILY_TIME_MODE.UP_TO_NOW
        );

        if (dataRange === CHART_DATA_RANGE.CUSTOM) {
            var fromMoment = String(this.$('.data-range-custom-from input').val());
            this.options.widget.setParamValue(
                'CHART_DATA_RANGE_FROM',
                moment.tz(fromMoment, this.dateTimePickerFormat, timezone).unix()
            );

            var toMoment = String(this.$('.data-range-custom-to input').val());
            this.options.widget.setParamValue(
                'CHART_DATA_RANGE_TO',
                moment.tz(toMoment, this.dateTimePickerFormat, timezone).unix()
            );
        } else if (dataRange !== CHART_DATA_RANGE.CUSTOM_MONTHLY_BILLING) {
            // If not custom range, remove custom times
            this.options.widget.setParamValue('CHART_DATA_RANGE_FROM', 0);
            this.options.widget.setParamValue('CHART_DATA_RANGE_TO', 0);
        }

        if (dataRange === CHART_DATA_RANGE.CUSTOM_DAILY) {
            var fromMoment = String(this.$('.daily-time-custom-from input').val());
            this.options.widget.setParamValue(
                'DAILY_TIME_FROM',
                // Get seconds from beginning of the day until the start time
                Math.abs(moment().startOf('day').unix() - moment(fromMoment, this.dailyTimeFormat).unix())
            );

            var toMoment = String(this.$('.daily-time-custom-to input').val());
            this.options.widget.setParamValue(
                'DAILY_TIME_TO',
                // Get seconds from beginning of the day until the end time
                Math.abs(moment().startOf('day').unix() - moment(toMoment, this.dailyTimeFormat).unix())
            );
        } else {
            // If not daily custom range, remove custom times
            this.options.widget.setParamValue('DAILY_TIME_FROM', 0);
            this.options.widget.setParamValue('DAILY_TIME_TO', 0);
        }

        if (dataRange == CHART_DATA_RANGE.CUSTOM_MONTHLY_BILLING) {
            var monthlyBillingDate = String(this.$('.monthly-billing-range-custom-wrapper select').val());
            this.options.widget.setParamValue('CHART_MONTHLY_BILLING_DATE', monthlyBillingDate);
            var monthlyDateTimestamp = moment().startOf('month').add(Number(monthlyBillingDate) - 1, 'day');
            var todaysDate = moment().startOf('day').format('DD');

            var fromMoment: string;
            var toMoment: string;

            if (Number(todaysDate) >= Number(monthlyBillingDate)) {
                // If the billing period ends today or earlier, have the period end the monthly billing date this month
                toMoment = moment(monthlyDateTimestamp).tz(timezone).startOf('day').format(this.dateTimePickerFormat);
                fromMoment = moment(toMoment).tz(timezone).subtract(1, 'month').format(this.dateTimePickerFormat);
            } else {
                // Otherwise, use the last full month's data
                toMoment = moment(monthlyDateTimestamp).tz(timezone).subtract(1, 'month').format(this.dateTimePickerFormat);
                fromMoment = moment(toMoment).tz(timezone).subtract(1, 'month').format(this.dateTimePickerFormat);
            }

            this.options.widget.setParamValue(
                'CHART_DATA_RANGE_FROM',
                moment.tz(fromMoment, this.dateTimePickerFormat, timezone).unix()
            );

            this.options.widget.setParamValue(
                'CHART_DATA_RANGE_TO',
                moment.tz(toMoment, this.dateTimePickerFormat, timezone).unix()
            );

        } else if (dataRange !== CHART_DATA_RANGE.CUSTOM) {
            // If not custom range, remove custom times
            this.options.widget.setParamValue('CHART_DATA_RANGE_FROM', 0);
            this.options.widget.setParamValue('CHART_DATA_RANGE_TO', 0);
        }

        return true;
    }

    matchAggPeriodToDataRange(order: string) {
        switch (order) {
            case "0":
            case "1": // DAY_1
            case "7": // DAY_TODAY
            case "8": // DAY_YESTERDAY
                return "2";
            case "2": // WEEK_1
            case "9": // WEEK_CURRENT
            case "10": // WEEK_LAST
                return "3";
            case "3": // MONTH_1
            case "11": // MONTH_CURRENT
            case "12": // MONTH_LAST
                return "4";
            case "4": // MONTH_3
                return "5";
            case "5": // MONTH_6
                return "6";
            case "6": // YEAR_1
            case "13": // YEAR_CURRENT
            case "14": // YEAR_LAST
                return "7";
            case "15": // CUSTOM
                return "15";
            case "16": // CUSTOM_DAILY
                return "16";
        }
    }

    checkCanSaveWidget() {
        const savable =
            _.filter(
                this.$(".widget-reference-select-channel").map(function () {
                    const el = $(this);
                    return el.val() || el.data("channelId");
                })
            ).length > 0;

        this.options.parentView.setSavable(savable);
    }

    remove() {
        this.stopListening();
        return super.remove();
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/modals/reports/modify_widgets/ModifyCSVDataWidgetView.ts